<app-spinner *ngIf="isLoading"></app-spinner>
<div *ngIf="isLoading !== true && error">
  <app-page-error [error]="error"></app-page-error>
</div>
<div *ngIf="isLoading !== true && !error">
  <ng-content></ng-content>
</div>
